import { cx } from 'class-variance-authority';
import { CircleAlert, CircleCheck, Info } from 'lucide-react';
import { useMemo } from 'react';
import useLangText from '@shared/hooks/useLangText';
import { LayoutBuilderTypeFull } from '@shared/types/process';
import { sanitizeLayoutInfoHtml } from '@shared/util/richTextHtml';

export type LayoutBuilderInfoBlock = Extract<
    LayoutBuilderTypeFull,
    { type: 'Info' }
>;

export const LayoutBlockViewInfo = ({
    block,
}: {
    block: LayoutBuilderInfoBlock;
}) => {
    const getLangText = useLangText();

    const iconComponent = useMemo(() => {
        switch (block.options.type) {
            case 'error':
                return <CircleAlert size={17} />;
            case 'info':
                return <Info size={17} />;
            case 'success':
                return <CircleCheck size={17} />;
            default:
                return <Info size={17} />;
        }
    }, [block.options.type]);

    const sanitizedHtml = useMemo(
        () => sanitizeLayoutInfoHtml(getLangText(block.options.text)),
        [block.options.text, getLangText],
    );

    return (
        <div
            className={cx(
                'text-editor-readOnly',
                `text-editor-${block.options.type}`,
                'mb-5',
            )}
        >
            <div className='text-editor-readOnly-icon'>{iconComponent}</div>
            <div
                className='text-editor-readOnly-text'
                dangerouslySetInnerHTML={{ __html: sanitizedHtml }}
            />
        </div>
    );
};
